import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { clsx } from 'clsx';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, hint, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-brand-950 mb-2">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          className={clsx(
            'w-full px-4 py-3 rounded-xl border bg-white transition-colors resize-none',
            'focus:outline-none focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500',
            error
              ? 'border-error-500 focus:ring-error-500/20 focus:border-error-500'
              : 'border-surface-200 hover:border-surface-300',
            className
          )}
          {...props}
        />
        {error && (
          <p className="mt-2 text-sm text-error-600">{error}</p>
        )}
        {hint && !error && (
          <p className="mt-2 text-sm text-surface-800">{hint}</p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
